import styled from "styled-components";
import HomeIcon from "../../assets/icons/Home.svg";
import Flow from "../../assets/icons/Flow.svg";
import GroupeIcon from "../../assets/icons/Group.svg";
import GlobalStyle from "../../helpers/Fonts";

const CaseSection = styled.section`
  display: grid;
  place-items: center;
  width: 100%;
  /* margin-top: 200px; */
  /* background-color: red; */
  /* height: 30px; */

  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }
`;

const HeaderText = styled.h1`
  font-size: ${(props) => props.size || "16px"};
  font-weight: ${(props) => props.weight || "400"};
  color: ${(props) => props.color || "#fff"};
  font-family: ${(props) => props.font || "Poppins"};
  margin-bottom: ${(props) => props.marginBottom || "0px"};
  letter-spacing: ${(props) => props.letterSpacing || "0px"};
  opacity: ${(props) => props.opacity || "1"};
`;

const Text = styled.p`
  font-size: ${(props) => props.size || "16px"};
  font-weight: ${(props) => props.weight || "400"};
  color: ${(props) => props.color || "#fff"};
  font-family: ${(props) => props.font || "Poppins"};
  margin-bottom: ${(props) => props.marginBottom || "0px"};
  letter-spacing: ${(props) => props.letterSpacing || "0px"};
  opacity: ${(props) => props.opacity || "1"};

  @media only screen and (max-width: 614px) {
    font-size: 12px;
  }
`;

const TextSection = styled.div``;

const CardContainer = styled.div`
  display: grid;
  place-items: center;
  width: 100%;
  /* background-color: blue; */
`;

const CardInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1303px;
  height: 250px;
  /* background-color: red; */

  @media only screen and (max-width: 1330px) {
    flex-direction: column;
    height: 500px;
    padding: 0 40px;
  }

  @media only screen and (max-width: 614px) {
    height: 390px;
  }
`;

const Card = styled.div`
  width: 400px;
  height: 130px;
  background-color: red;
  border-radius: 9px;
  background-color: ${(props) => props.backgroundColor || "#0A0A0A"};
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
  /* padding: 0 40px; */

  @media only screen and (max-width: 614px) {
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    align-items: center;
    padding: 5px;
  }
`;

const CardTextContainer = styled.div`
    width: 250px;
    padding: 0;

    @media only screen and (max-width: 614px) {
    width: 180px;
  }
`

const CardIcon = styled.img`
  width: 50px;
  height: 50px;
  font-family: ${(props) => props.font || "Poppins"};

  @media only screen and (max-width: 614px) {
    width: 30px;
    height: 30px;
  }
`;

function CasesSection() {
  return (
    <CaseSection>
      <GlobalStyle />
      <TextSection>
        <HeaderText size="48px" font="Poppins Bold">
          Use Cases
        </HeaderText>
      </TextSection>
      <CardContainer>
        <CardInnerContainer>
          <Card>
            <CardIcon src={HomeIcon} />
            <CardTextContainer>
              <Text font="Poppins Regular" size="18px">
                Manage Airbnb properties from our dashboard
              </Text>
            </CardTextContainer>
          </Card>
          <Card>
            <CardIcon src={GroupeIcon} />
            <CardTextContainer>
              <Text font="Poppins Regular" size="18px">
                Create fully manged self checkin for your guests
              </Text>
            </CardTextContainer>
          </Card>
          <Card backgroundColor="#1E1E1E">
            <CardIcon src={Flow} />
            <CardTextContainer>
              <Text font="Poppins Regular" size="18px" opacity=".5">
                Workflows (Coming Soon!)
              </Text>
            </CardTextContainer>
          </Card>
        </CardInnerContainer>
      </CardContainer>
    </CaseSection>
  );
}

export default CasesSection;
